import axios from '@axios'

export const state = {
  packages: [],
  currentPage: 1,
  perPage: 15,
  totalPages: 1,
  totalRecords: 0,
}

export const getters = {
  allPackages: (state) => state.packages,
  currentPage: (state) => state.currentPage,
  totalPages: (state) => state.totalPages,
  perPage: (state) => state.perPage,
  totalRecords: (state) => state.totalRecords,
}

export const mutations = {
  GET_PACKAGES: (state, data) => {
    state.packages = []
    state.totalRecords = 0
    state.totalPages = 1
    if (!data) return false
    let { packages, page, perPage, totalRecords, totalPages } = data
    state.packages = packages
    state.totalPages = totalPages
    state.currentPage = page
    state.totalRecords = totalRecords
    state.perPage = perPage
  },
  ADD_PACKAGE: (state, data) => {
    if (!data) return false
    state.packages.push(data)
  },
  UPDATE_PACKAGE: (state, data) => {
    if (!data) return false
    state.packages.forEach((element, index) => {
      if (element.id === data.id)
        state.packages[index] = Object.assign({}, data)
    })
  },
  DELETE_PACKAGE: (state, data) => {
    if (!data) return false
    state.packages = state.packages.filter((ops) => ops.id !== data.id)
  },
  DEFAULT_PACKAGE: (state, data) => {
    state.packages.forEach((element) => {
      if (element.id === data.id) {
        element.default = data.default
      } else if (element.default === data.default) {
        element.default = false
      }
    })
  },
}

export const actions = {
  async getPackages({ commit }, param = []) {
    return axios.get(`/billing/packages`).then((resp) => {
      if (resp.status === 200) {
        commit('GET_PACKAGES', resp.data)
      } else {
        commit('GET_PACKAGES', [])
      }
    })
  },
  async getPackage({ commit }, data = {}) {
    return axios.get(`/billing/package/${data.id}`)
  },
  async createPackage({ commit }, data = {}) {
    return axios.post(`/billing/package`, data).then((resp) => {
      if (resp.status === 201) {
        commit('ADD_PACKAGE', resp.data)
      }
    })
  },
  async updatePackage({ commit }, data = {}) {
    return axios.put(`/billing/package`, data).then((resp) => {
      if (resp.status === 200) {
        commit('UPDATE_PACKAGE', resp.data)
      }
    })
  },
  async deletePackage({ commit }, data = {}) {
    return axios.delete(`/billing/package/${data.id}`).then((resp) => {
      if (resp.status === 204) {
        commit('DELETE_PACKAGE', data)
      }
    })
  },

  async defaultInterPackage({ commit, dispatch }, payload) {
    await axios
      .patch(`/billing/packages/default-international`, payload)
      .then((resp) => {
        if (resp.status === 200) {
          commit('DEFAULT_PACKAGE', resp.data)
        }
      })
  },
  async defaultLocalPackage({ commit, dispatch }, payload) {
    await axios
      .patch(`/billing/packages/default-local`, payload)
      .then((resp) => {
        if (resp.status === 200) {
          commit('DEFAULT_PACKAGE', resp.data)
        }
      })
  },
}
